import React from "react";
import './VideoSection.css'
import {Props} from "./interface";

const VideoSection = (props: Props) => {

    return (
        <div className={`video-section`}>
            video Section Here
        </div>
    )
}
export default VideoSection